import * as React from 'react';
import S from './Breadcrumb.styles';
export var BackgroundValues;
(function (BackgroundValues) {
    BackgroundValues["Beige"] = "beige";
    BackgroundValues["White"] = "white";
})(BackgroundValues || (BackgroundValues = {}));
const Breadcrumb = ({ background, items, spacingBelow = true }) => {
    return (React.createElement(S.Container, { "data-background": background && background !== '' ? background : BackgroundValues.White, "data-spacing-below": spacingBelow },
        React.createElement(S.List, { "aria-label": "breadcrumb" }, items.map((item, i) => (React.createElement(S.Item, { key: `breadcrumb-${i}` },
            React.createElement(S.ItemLink, { href: item.url, title: item.text, "aria-current": i === items.length - 1 ? 'location' : undefined }, item.text)))))));
};
export default Breadcrumb;
